<template>
  <div id="app">
    <Header />
    <div
      class="content-wrap"
      :class="shouldShowHilites() ? 'has-sidebar' : 'no-sidebar'"
    >
      <div v-if="mode === 'player'" class="left-col">
        <PageHeader :player="player" :video="video" />
        <Player ref="playerComponent" :player="player" :video="video" :type="video.type" :virtualDirector="video.virtualDirector" :autoplay="false">
          <template v-slot:below-player-content>
            <RecordButton v-if="player.contentType === 'event'" :isPlaying="isPlaying" :player="player" />
          </template>
        </Player>
        <InfoBox :video="video" />
      </div>
      <div v-if="shouldShowHilites()" class="right-col">
        <HiLitesSidebar />
      </div>
      <Editor :editor="editor" v-if="mode === 'editor'" />
    </div>
    <Footer />
    <router-view />
    <StateUI />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Player from "@/components/Player";
import PageHeader from "@/components/PageHeader";
import HiLitesSidebar from "@/components/HiLitesSidebar";
import StateUI from "@/components/StateUI";
import RecordButton from "@/components/RecordButton";
import InfoBox from "@/components/InfoBox";
import Footer from "@/components/Footer";
import Editor from "@/components/editor/Editor";

export default {
  name: "App",
  components: {
    Header,
    StateUI,
    Player,
    PageHeader,
    HiLitesSidebar,
    InfoBox,
    RecordButton,
    Editor,
    Footer
  },
  methods: {
    shouldShowHilites() {
      if (this.hilites.length && this.mode === 'player' && this.player.contentType === "event") {
        return true;
      } else if (this.player.contentType === "hilite" && this.hilites.length > 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    isPlaying() {
      if (this.$refs.playerComponent) {
        return this.$refs.playerComponent.playing;
      } else {
        return false;
      }
    },
    hilites() {
      return this.$store.state.hilites;
    },
    video() {
      return this.$store.state.video;
    },
    player() {
      return this.$store.state.player;
    },
    gameEvents() {
      return this.$store.state.gameEvents;
    },
    editor() {
      return this.$store.state.editor;
    },
    mode() {
      return this.$store.state.mode;
    }
  }
};
</script>

<style lang="stylus" scoped>
#app
  position: relative;
  min-height: 100vh;
  padding-bottom: 60px;
.content-wrap
  full-width-content()
  margin: 60px auto 35px auto
  fluid margin-top, 60, 25, null, 768
  display: flex
  position: relative
  @media screen and (max-width: mobile-landscape)
    flex-wrap: wrap
  &.no-sidebar
    .left-col
      width: 100%
  &.has-sidebar
    .left-col
      width: 740px
      @media screen and (max-width: mobile-landscape)
        width: 100%
    .right-col
      width: 290px
      margin-left: 35px
      @media screen and (max-width: mobile-landscape)
        width: 100%
        margin-left: 0px
        margin-top: 25px

#app
  font-family "hind", Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
</style>
